import React from 'react';
import SharedHelmet from '../../Helmet';
const TITLE = 'Percentage List for Any Number from 1 to 100';
const DESCRIPTION = 'Use this tool to easily and accurately calculate the percentage for any number between 1 and 100. This calculator provides you with a quick and efficient way to find the percentage of specific numbers.';
const KEYWORDS = 'percentage calculator, calculate percentage, percentage tool, percentage, calculate numbers, numbers from 1 to 100';
const OG_URL = 'https://do-calculate.com/calculator/en/percentage_converter/percentage_list/';
const numberToArabic = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
    11: 'eleven',
    12: 'twelve',
    13: 'thirteen',
    14: 'fourteen',
    16: 'sixteen',
    17: 'seventeen',
    18: 'eighteen',
    19: 'nineteen',
    21: 'twenty-one',
    22: 'twenty-two',
    23: 'twenty-three',
    24: 'twenty-four',
    26: 'twenty-six',
    27: 'twenty-seven',
    28: 'twenty-eight',
    29: 'twenty-nine',
    31: 'thirty-one',
    32: 'thirty-two',
    33: 'thirty-three',
    34: 'thirty-four',
    36: 'thirty-six',
    37: 'thirty-seven',
    38: 'thirty-eight',
    39: 'thirty-nine',
    41: 'forty-one',
    42: 'forty-two',
    43: 'forty-three',
    44: 'forty-four',
    45: 'forty-five',
    46: 'forty-six',
    47: 'forty-seven',
    48: 'forty-eight',
    49: 'forty-nine',
    50: 'fifty',
    51: 'fifty-one',
    52: 'fifty-two',
    53: 'fifty-three',
    54: 'fifty-four',
    55: 'fifty-five',
    56: 'fifty-six',
    57: 'fifty-seven',
    58: 'fifty-eight',
    59: 'fifty-nine',
    60: 'sixty',
    61: 'sixty-one',
    62: 'sixty-two',
    63: 'sixty-three',
    64: 'sixty-four',
    65: 'sixty-five',
    66: 'sixty-six',
    67: 'sixty-seven',
    68: 'sixty-eight',
    69: 'sixty-nine',
    70: 'seventy',
    71: 'seventy-one',
    72: 'seventy-two',
    73: 'seventy-three',
    74: 'seventy-four',
    76: 'seventy-six',
    77: 'seventy-seven',
    78: 'seventy-eight',
    79: 'seventy-nine',
    80: 'eighty',
    81: 'eighty-one',
    82: 'eighty-two',
    83: 'eighty-three',
    84: 'eighty-four',
    85: 'eighty-five',
    86: 'eighty-six',
    87: 'eighty-seven',
    88: 'eighty-eight',
    89: 'eighty-nine',
    90: 'ninety',
    91: 'ninety-one',
    92: 'ninety-two',
    93: 'ninety-three',
    94: 'ninety-four',
    95: 'ninety-five',
    96: 'ninety-six',
    97: 'ninety-seven',
    98: 'ninety-eight',
    99: 'ninety-nine',
    100: 'one hundred'
};
const PercentageList = () => {
    const numbers = Object.keys(numberToArabic).map(Number);
    return (
        <div>
            <div className="container ">
                <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
                <div>
                    <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                    <hr />
                    <div className="alert alert-secondary" role="alert">
                        <p>{DESCRIPTION}</p>
                    </div>
                </div>
                <hr />
                <table >
                    <thead>
                        <tr>
                            <th >Percentage</th>
                            <th >Go to Calculator</th>
                        </tr>
                    </thead>
                    <tbody>
                        {numbers.map((number) => {
                            const percentage = number;
                            const arabicWord = numberToArabic[number];
                            return (
                                <tr key={number}>
                                    <td>{percentage}% - {arabicWord}</td>
                                    <td>
                                        <a href={`/calculator/en/percentage_converter/${percentage}/`}>
                                            Go to {percentage}% Calculator
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <br />
            </div>
        </div>
    );
};
export default PercentageList;
